import { BrokerageStatusCodeList } from "../BrokerageStatusCodeList";
import { BrokerageWorkflowProfileList } from "../BrokerageWorkflowProfileList";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageWorkflowMasterFile extends Layout {
	layoutBrokerageWorkflowProfileList: BrokerageWorkflowProfileList;
    layoutB: BrokerageStatusCodeList;
	stepStatusCodes: Step;
	stepbrworkflow: Step;
	stepperBrokerageWorkflow: Stepper;
}
